/* rt-gallery-nav — galeria mobile da PDP, partilhada com a janela de quick-add: swipe, contador, loop, 200/400 ms.

   window.rtGalleryNav(images, counter, opts)
     images  — o <product-images> (slider nativo do Broadcast, .product__images--mobile-slider)
     counter — o .rt-pdp-counter desse produto; é movido para o fim do images
     opts.always — comporta-se como no mobile em qualquer largura (a janela de quick-add, que no
                   desktop é um painel da largura de um telemóvel) */
(function () {
  if (window.rtGalleryNav) return;

  window.rtGalleryNav = function (images, counter, opts) {
    if (!images || !counter || images.dataset.rtReady) return;
    var slides = images.querySelector('.product__slides');
    if (!slides) return;
    images.dataset.rtReady = '1';
    images.appendChild(counter);
    var counterText = counter.querySelector('[data-rt-counter]');
    // barra de progresso (Theme settings → rt_pdp_mobile_nav: bar), no lugar do número e das setas
    var bar = counter.querySelector('[data-rt-bar]');
    var mq = opts && opts.always ? { matches: true } : window.matchMedia('(max-width: 749px)');

    // O total conta as slides no DOM, não product.media (hide_variants pode tirar algumas).
    var real = Array.prototype.slice.call(slides.querySelectorAll('.product__slide[data-media-id]'));
    var n = real.length;
    if (n < 2) return;
    function idAt(i) { return real[i].getAttribute('data-media-id'); }
    function indexOf(id) {
      for (var i = 0; i < n; i++) if (idAt(i) === id) return i;
      return -1;
    }
    function activeIndex() { return Math.max(0, indexOf(images.getAttribute('data-active-media'))); }

    // --- cópias das pontas (só mobile) ---
    function makeClone(src) {
      var c = src.cloneNode(true);
      c.classList.add('rt-slide-clone');
      c.classList.remove('media--active', 'media--hiding', 'media--hidden');
      ['data-media-id', 'data-image-id', 'data-slide', 'id', 'tabindex'].forEach(function (a) { c.removeAttribute(a); });
      c.setAttribute('aria-hidden', 'true');
      c.querySelectorAll('[id]').forEach(function (e) { e.removeAttribute('id'); });
      c.querySelectorAll('[data-zoom-image]').forEach(function (e) { e.removeAttribute('data-zoom-image'); });
      c.querySelectorAll('[tabindex], button, a').forEach(function (e) { e.setAttribute('tabindex', '-1'); });
      c.querySelectorAll('img').forEach(function (e) { e.removeAttribute('fetchpriority'); });
      return c;
    }
    var headClone = null, tailClone = null;
    function addClones() {
      if (headClone) return;
      headClone = makeClone(real[n - 1]);
      tailClone = makeClone(real[0]);
      slides.insertBefore(headClone, real[0]);
      slides.appendChild(tailClone);
      invalidate();
      slides.scrollLeft = pos(activeIndex());
    }
    function removeClones() {
      if (!headClone) return;
      headClone.remove(); tailClone.remove();
      headClone = tailClone = null;
      invalidate();
    }

    // INP: stride memoizado; só o resize muda o layout.
    var _stride = null;
    function invalidate() { _stride = null; }
    function stride() {
      if (_stride == null) {
        // escondida (display:none) mede 0: não se guarda, senão o scroll dividia por 0 para sempre
        // de ponta a ponta: o passo real é fracionário (338,6) e o offsetLeft é inteiro (338). Medido só
        // entre as duas primeiras, o erro × n punha a última foto na zona da cópia e o wrapShift ficava
        // a saltar entre a cópia e a última para sempre (a 356/375/390 px).
        var s = ((real[n - 1].offsetLeft - real[0].offsetLeft) / (n - 1)) || slides.clientWidth;
        if (!s) return 1;
        _stride = s;
      }
      return _stride;
    }
    function pos(i) { return (i + (headClone ? 1 : 0)) * stride(); }
    // posição de scroll → índice "cru": -1 = cópia da última, n = cópia da 1.ª
    function rawIndex() { return Math.round(slides.scrollLeft / stride()) - (headClone ? 1 : 0); }

    function markActive(id) {
      counter.hidden = false;
      var at = Math.max(0, indexOf(id)) + 1;
      if (counterText) counterText.textContent = at + '/' + n;
      if (bar) bar.style.width = (at / n * 100) + '%';
    }

    // Scroll rápido (200ms, ease-out). `animating` faz o scroll handler ignorar estes
    // frames — é o código a mexer e não o dedo. O snap (x mandatory) desliga-se durante a
    // animação: ligado, puxava cada frame de volta à foto e ela trocava de uma vez.
    var animating = false;
    function animateScroll(to, dur, done) {
      var from = slides.scrollLeft, d = to - from;
      if (!d) { if (done) done(); return; }
      animating = true;
      slides.style.scrollSnapType = 'none';
      var t0 = performance.now();
      function step(now) {
        // o timestamp do rAF é o início do frame e pode ser anterior ao clique → p < 0 recuava
        var p = Math.min(1, Math.max(0, (now - t0) / dur));
        slides.scrollLeft = from + d * (1 - Math.pow(1 - p, 3));
        if (p < 1) return requestAnimationFrame(step);
        if (done) done();
        slides.style.scrollSnapType = '';
        animating = false;
      }
      requestAnimationFrame(step);
    }
    function scrollToIndex(i) {
      var target = pos(i), dist = Math.abs(slides.scrollLeft - target);
      if (dist <= stride() / 2) return;
      if (dist > stride() * 1.5) slides.scrollLeft = target;
      else animateScroll(target, 200);
    }

    // Selecção vinda do próprio scroll: o observer não deve voltar a mexer no scroll
    // (senão, numa cópia, puxava a galeria para a foto verdadeira a meio do gesto).
    var selectedByScroll = null;
    function select(i, fromScroll) {
      var id = idAt(i);
      if (id === images.getAttribute('data-active-media')) return;
      if (fromScroll) selectedByScroll = id;
      images.dispatchEvent(new CustomEvent('theme:media:select', {bubbles: true, detail: {id: id}}));
    }

    // Na zona de uma cópia (antes da 1.ª ou depois da última) → desloca um ciclo inteiro
    // (n * stride). O que está à vista é igual dos dois lados, por isso não se vê, e
    // funciona mesmo a meio do snap. Corre quando o scroll pára e logo no toque, para
    // um 2.º swipe rápido não encontrar a parede do fim da fila.
    var touching = false, settleT = 0;
    function wrapShift() {
      if (!headClone || animating) return;
      var L = slides.scrollLeft, span = n * stride();
      if (L < pos(0) - 1) slides.scrollLeft = L + span;
      else if (L > pos(n - 1) + 1) slides.scrollLeft = L - span;
    }
    function settle() { if (!touching) wrapShift(); }

    // scroll (dedo) → foto activa, um check por frame
    var rafPending = false;
    slides.addEventListener('scroll', function () {
      if (!mq.matches || animating) return;
      clearTimeout(settleT);
      settleT = setTimeout(settle, 100);
      if (rafPending) return;
      rafPending = true;
      requestAnimationFrame(function () {
        rafPending = false;
        var raw = Math.min(n, Math.max(-1, rawIndex()));
        select((raw + n) % n, true);
      });
    }, {passive: true});
    slides.addEventListener('touchstart', function () {
      touching = true;
      wrapShift();
      preloadNeighbours(activeIndex());
    }, {passive: true});
    ['touchend', 'touchcancel'].forEach(function (t) {
      slides.addEventListener(t, function () {
        touching = false;
        clearTimeout(settleT);
        settleT = setTimeout(settle, 100);
      }, {passive: true});
    });

    // Vizinhas carregadas antes do swipe (incluindo as cópias nas pontas).
    function eager(el) {
      var img = el && el.querySelector('img[loading="lazy"]');
      if (img) img.setAttribute('loading', 'eager');
    }
    function preloadNeighbours(i) {
      eager(real[i - 1]); eager(real[i + 1]);
      if (i === 0) eager(headClone);
      if (i === n - 1) eager(tailClone);
    }

    // foto activa (seta, variante) → contador + scroll
    new MutationObserver(function () {
      var id = images.getAttribute('data-active-media');
      markActive(id);
      preloadNeighbours(Math.max(0, indexOf(id)));
      if (id === selectedByScroll) { selectedByScroll = null; return; }
      if (mq.matches) scrollToIndex(Math.max(0, indexOf(id)));
    }).observe(images, {attributes: true, attributeFilter: ['data-active-media']});

    // setas: uma foto para trás/frente; nas pontas passa pela cópia e dá a volta
    // 400 ms entre toques: cliques mais rápidos são ignorados.
    var STEP_COOLDOWN = 400, lastStep = 0;
    counter.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-rt-step]');
      if (!btn) return;
      var now = Date.now();
      if (now - lastStep < STEP_COOLDOWN) return;
      lastStep = now;
      var raw = activeIndex() + Number(btn.getAttribute('data-rt-step'));
      var to = (raw + n) % n;
      if (raw === to || !headClone || !mq.matches) return select(to);
      selectedByScroll = idAt(to);
      select(to);
      animateScroll(pos(raw), 200, function () { slides.scrollLeft = pos(to); });
    });

    // Mudou a largura da galeria (resize, ou a janela de quick-add que se volta a abrir: um <dialog>
    // fechado é display:none e o browser põe o scrollLeft a 0, que é a CÓPIA da última foto) →
    // medir de novo e voltar a pôr à vista a foto ativa. Um observer por galeria, sem acumular.
    if (window.ResizeObserver) {
      new ResizeObserver(function () {
        invalidate();
        if (headClone && slides.clientWidth && !touching && !animating) slides.scrollLeft = pos(activeIndex());
      }).observe(slides);
    } else {
      window.addEventListener('resize', invalidate, {passive: true});
    }

    function syncMode() { if (mq.matches) addClones(); else removeClones(); }
    if (mq.addEventListener) mq.addEventListener('change', syncMode);
    syncMode();
    markActive(images.getAttribute('data-active-media'));
  };

  /* rtThumbsFit — PDP em desktop (Ruben 2026-10-25):
     - mede a foto grande e põe no <product-images> --rt-thumbs-h (altura da foto: o rt-product.css
       limita a coluna de miniaturas a isso) e --rt-slides-left (onde a foto começa: o selo à esquerda
       conta daí, e não do canto da coluna);
     - com data-rt-thumbs-fit (Theme settings → rt_pdp_thumbs_fit), a miniatura escolhida (clique,
       variante) vai para o 2.º lugar da coluna. O scrollToThumb do product-thumbs (Broadcast) só a
       punha à vista; troca-se por este, sem mexer no ficheiro dele. Na coluna horizontal fica o dele. */
  window.rtThumbsFit = function (images) {
    // a marca de «já correu» NÃO pode ser data-rt-thumbs-fit: esse é o atributo do setting (Liquid)
    if (!images || images.dataset.rtThumbsReady) return;
    var slides = images.querySelector('.product__slides');
    if (!slides) return;
    images.dataset.rtThumbsReady = '1';
    function measure() {
      images.style.setProperty('--rt-thumbs-h', slides.offsetHeight + 'px');
      images.style.setProperty('--rt-slides-left', slides.offsetLeft + 'px');
    }
    if (window.ResizeObserver) new ResizeObserver(measure).observe(slides);
    measure();

    if (!images.hasAttribute('data-rt-thumbs-fit') || !window.customElements) return;
    customElements.whenDefined('product-thumbs').then(function () {
      var proto = customElements.get('product-thumbs').prototype;
      if (proto.rtSecond) return;
      var original = proto.scrollToThumb;
      proto.rtSecond = true;
      proto.scrollToThumb = function () {
        var holder = this.thumbSlider;
        if (!holder || getComputedStyle(holder).flexDirection !== 'column' || !this.closest('product-images[data-rt-thumbs-fit]')) {
          return original.call(this);
        }
        var items = holder.querySelectorAll('[data-thumb-item]');
        for (var i = 0; i < items.length; i++) {
          if (!items[i].classList.contains('is-active')) continue;
          // a de cima fica à vista; o browser trava no fim da lista
          var top = i > 0 ? items[i - 1].offsetTop - items[0].offsetTop : 0;
          holder.scrollTo({top: top, behavior: 'smooth'});
          return;
        }
      };
    });
  };
})();
